import { render, staticRenderFns } from "./ApproveQuerylogsForm.vue?vue&type=template&id=f9c8752e&scoped=true&"
import script from "./ApproveQuerylogsForm.vue?vue&type=script&lang=js&"
export * from "./ApproveQuerylogsForm.vue?vue&type=script&lang=js&"
import style0 from "./ApproveQuerylogsForm.vue?vue&type=style&index=0&id=f9c8752e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9c8752e",
  null
  
)

export default component.exports